import MatchPeople from './views/MatchPeople';
import MatchGroup from './views/MatchGroup';
import Messages from './views/Messages';
import Profile from './views/Profile';
import Games from './views/Games';
import SignUp from './views/Auth/SignUp';
import Group from './views/Group';
import LikedMe from './views/LikedMe';

import {
  HomeIcon
} from './components/Icons/Icons';

//MatchPeople

export const account = [
  {
    path: '/',
    name: 'People',
    icon: <HomeIcon color="inherit" />,
    component: MatchPeople,
    layout: '/',
  },
  {
    path: 'games',
    name: 'Games',
    icon: <HomeIcon color="inherit" />,
    component: Games,
    layout: '/',
  },
  {
    path: 'liked-me',
    name: 'Liked Me',
    icon: <HomeIcon color="inherit" />,
    component: LikedMe,
    layout: '/',
  },
  {
    path: 'group',
    name: 'Group',
    icon: <HomeIcon color="inherit" />,
    component: MatchGroup,
    layout: '/',
  },
  {
    path: 'group-profile',
    name: 'Group Edit',
    icon: <HomeIcon color="inherit" />,
    component: Group,
    layout: '/',
  },
  {
    path: 'messages',
    name: 'Messages',
    icon: <HomeIcon color="inherit" />,
    component: Messages,
    layout: '/',
  },
  {
    path: 'profile',
    name: 'Profile',
    icon: <HomeIcon color="inherit" />,
    component: Profile,
    layout: '/',
  },
  {
    path: 'faqs',
    name: 'Terms & Conditions',
    icon: <HomeIcon color="inherit" />,
    component: (<></>),
    layout: '/',
  },  
  {
    path: 'terms-and-conditions',
    name: 'Terms & Conditions',
    icon: <HomeIcon color="inherit" />,
    component: (<></>),
    layout: '/',
  },
  {
    path: 'privacy-policy',
    name: 'Privacy Policy',
    icon: <HomeIcon color="inherit" />,
    component: (<></>),
    layout: '/',
  },
];

export const auth = [
  {
    path: '/sign-up',
    name: 'Sign Up',
    icon: <HomeIcon color="inherit" />,
    component: SignUp,
    layout: '/auth',
  }
];

const routes = [...account, ...auth];
export default routes;